// Menu Hook - AgentBheem ERP
import { useQuery } from '@tanstack/react-query'
import { menuService } from '@/services/menuService'
import type { MenusResponse } from '@/types/menu'

/**
 * React Query hook for fetching menus
 * Uses 20s staleTime matching backend cache TTL
 */
export function useMenus() {
  return useQuery<MenusResponse>({
    queryKey: ['menus'],
    queryFn: menuService.getMenus,
    staleTime: 20_000, // 20 seconds - matches backend cache
    refetchOnWindowFocus: true,
    retry: 2,
  })
}

/**
 * Get menu paths for route validation
 */
export function useMenuPaths() {
  const { data: menus } = useMenus()

  const paths = new Set<string>()

  if (menus) {
    // Extract paths from grouped menus
    menus.grouped.forEach((group) => {
      group.items.forEach((item) => {
        if (item.path) paths.add(item.path)
        item.children?.forEach((child) => {
          if (child.path) paths.add(child.path)
        })
      })
    })

    // Extract paths from ungrouped menus
    menus.ungrouped.forEach((item) => {
      if (item.path) paths.add(item.path)
      item.children?.forEach((child) => {
        if (child.path) paths.add(child.path)
      })
    })
  }

  return paths
}
